import { render, staticRenderFns } from "./SkillScoringPopup.vue?vue&type=template&id=33c2c188&"
import script from "./SkillScoringPopup.vue?vue&type=script&lang=js&"
export * from "./SkillScoringPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports